import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

const RETRY_COUNT = 2;
const RETRY_TIMEOUT = 500;

const retryStatusPredicate = (status: string) => status.startsWith('5');

const shouldRetry = (error: HttpErrorResponse) => {
  if (retryStatusPredicate(String(error.status))) {
    return timer(RETRY_TIMEOUT);
  }

  throw error;
};

@Injectable()
export class HttpRetryInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method === 'GET') {
      return next.handle(request).pipe(retry({ count: RETRY_COUNT, delay: shouldRetry }));
    }

    return next.handle(request);
  }
}
